module.exports = __webpack_public_path__ + "static/media/upload-solid.acf4c8e7.svg";